<dx-button
  text="{{ 'NOTIFICATION_TEMPLATES_KEYWORDS_DICTIONARY' | translate }}"
  [icon]="this.getIcon()"
  (click)="this.expanded = !this.expanded"
  class="btn btn-light d-flex"></dx-button>

@if (this.expanded) {
  <dx-data-grid
    class="datagrid-admin"
    [dataSource]="keyWords$ | async"
    [showBorders]="true"
    [allowColumnResizing]="true"
    [hoverStateEnabled]="true"
    keyExpr="id"
    stylingMode="outlined"
    rowTemplate="rowTemplate"
    noDataText="{{ 'DATA_NOT_FOUND' | translate }}"
    (onRowClick)="rowClick($event)">
    <!--<dxo-group-panel [visible]="true"></dxo-group-panel>-->
    <!--<dxo-grouping [autoExpandAll]="true"></dxo-grouping>-->
    <dxo-selection mode="single"></dxo-selection>
    <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
    <dxi-column dataField="name" caption="{{ 'NOTIFICATION_TEMPLATES_KEYWORD_NAME' | translate }}"></dxi-column>
    <dxi-column dataField="description" caption="{{ 'NOTIFICATION_TEMPLATES_KEYWORD_DESCRIPTION' | translate }}"></dxi-column>
    <dxi-column dataField="subsystem?.value" caption="{{ 'NOTIFICATION_TEMPLATES_TYPE' | translate }}"></dxi-column>
    <tbody class="dx-row" *dxTemplate="let entity of 'rowTemplate'">
      <tr class="main-row">
        <td>
          {{ this.getFormatedKeyWord(entity.data.name) }}
        </td>
        <td>
          {{ entity.data.description }}
        </td>
        <td>
          {{ entity.data.subsystem?.value }}
        </td>
      </tr>
    </tbody>
    <dxo-paging [pageSize]="10"></dxo-paging>
    <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 15, 20]"></dxo-pager>
  </dx-data-grid>
}
